module.exports = __webpack_public_path__ + "media/images/mock-thumbs/un-champions-banner-d37a7cc82696011977c9d28b05dd7cd3.png";